import React, { useEffect, useRef, useState } from "react"
import Element from "@bappweb/element"
import Panel from "@bappweb/panel"
import DataTable, { DateTableHandleType, GridOptionsType } from "@bappweb/datatable"
import Block from "@bappweb/block"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"

const Table = ({ tableData, index, campaingsHeader, campaingsHeaderMobil }) => {

    const refTable = useRef<DateTableHandleType>(null)
    const size = useDeviceSize()
    const [campaingsTextMobile, setCampaingsTextMobile] = useState<any[]>([]);
    const [campaingsTextWeb, setCampaingsTextWeb] = useState<any[]>([]);

    const renderCustomColumns = () => {
        return (val, row) => {
            return (
                <Block type="ul" >
                    {/*eslint-disable */}
                    {val.map((element, i) => {
                        return (
                            <Element key={i} type="li">
                                <Element type="span">
                                    {element}
                                </Element>
                            </Element>
                        )
                    })}
                    {/*eslint-enable */}
                </Block>
            )
        }
    }

    useEffect(() => {
        refTable.current?.loadWithDataArray(tableData)
        const newJsonData = campaingsHeader[index].data;

        setCampaingsTextWeb(newJsonData.map((itemNew: any, indexNew) => {
            if (itemNew.prop === "campaign" || itemNew.prop === "priceAdvantagePeriod" || itemNew.prop === "serviceFeeAdvantageDuration") {
                return ({ title: itemNew.title, prop: itemNew.prop, sortable: false });
            }
            else {
                return ({ title: itemNew.title, prop: itemNew.prop, sortable: false, render: renderCustomColumns() });
            }
        }))
    }, [size, tableData])

    useEffect(() => {
        refTable.current?.loadWithDataArray(tableData)
        const newJsonData = campaingsHeaderMobil[index].data;

        setCampaingsTextMobile(newJsonData.map((itemNew: any, indexNew) => {
            if (indexNew === 0) {
                return ({ title: itemNew.title, prop: itemNew.prop, className: itemNew.className });
            }
            else {
                return ({ title: itemNew.title, prop: itemNew.prop, sortable: false, render: renderCustomColumns() });
            }
        }))
    }, [size, tableData])

    const getColumnsOptions = () => {
        let gridOptionsType: GridOptionsType = {
            columns: [],
            noDataMessage: "",
            pageSize: 0
        }
        if (size === Sizes.xs) {
            gridOptionsType.columns = campaingsTextMobile
        }
        else {
            gridOptionsType.columns = campaingsTextWeb
        }

        return gridOptionsType.columns
    }

    const gridOptions = {
        pageSize: 5,
        pageAble: false,
        noDataMessage: "Kayıt bulunamadı.",
        virtualization: false,
        virtualizationLoadSize: 250,
        className: 'table-header',
        scrollHeight: "600px",
        columns: getColumnsOptions()
    }

    return (
        <Page padding={false}>
            <Panel hasFooter={false} noHeader={true} className="campaign-container">
                <DataTable ref={refTable} gridOptions={gridOptions} />
            </Panel>
        </Page>
    )
}

export default Table
